<template>
  <div class="col-sm-12" @click.stop="">
      <div class="row">
        <div class="col-8 item-text-cont">
          <span class="item-title">{{ user.last_name }}, {{ user.first_name }}</span>
        </div>
        <div
          class="col-4 d-flex justify-content-end"
        >
          <button
            class="btn btn-success"
            @click="$emit('add')"
          >
            {{ $t('common.add_new') }}
          </button>
        </div>
      </div>
        <vue3-datatable
            v-if="certificates.length > 0"
            :rows="certificates"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            height="100%"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        >
            <template #name="row">
                {{ row.value.type.name }}
            </template>
            <template #planned="row">
                {{ row.value && row.value.planned ? 'X' : '' }}
            </template>
            <template #granted_day="row">
                {{ getShortDateString(row.value.granted_day) }}
            </template>
            <template #expiration_day="row">
                {{ getShortDateString(row.value.expiration_day) }}
            </template>
        </vue3-datatable>
  </div>
</template>

<script>
import {timeUtils} from '.././mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'UsersCertificateList',
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            fields: [
                {field: 'name', title: this.$t('certificate.certificate_type'), sort: this.sortable, headerClass: 'routa-table-header'},
                {field: 'planned', title: this.$t('certificate.certificate_planned'), sort: this.sortable, headerClass: 'routa-table-header'},
                {field: 'granted_day', title: this.$t('certificate.granted_day'), sort: this.sortable, headerClass: 'routa-table-header'},
                {field: 'expiration_day', title: this.$t('certificate.expiration_day'), sort: this.sortable, headerClass: 'routa-table-header'}
            ],
            certificates: []
        }
    },
    watch: {
        user: function () {
            this.certificates = []
            this.$nextTick(() => {
                this.certificates = this.user.certificates
            })
        }
    },
    mounted() {
        this.certificates = this.user.certificates
    },
    methods: {
        emitDetails: function (result) {
            // Find item from original items and emit request to edit
            let p = this.user.certificates.find(item => item.id === result.id)
            if (p) {
                this.$emit('edit', p)
            }
        }
    }
}
</script>
